import { useLocalStorageState } from '@frontend/common';
import { getApplicationDisplayName } from '@frontend/functionality/utils';
import { useAccountRepository, useBrandingRepository } from '@frontend/repository';
import { SpotBadge } from '@frontend/spot/badge';
import { useState } from 'react';
import { LuLayoutGrid } from 'react-icons/lu';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';

import { useMenuRepository } from '../../menu/menu-repository';
import AppSelectModal from '../../modal/app-select-modal/app-select-modal.component';

const ID = 'mobile-home-header';

const DEVICE_LOCATION_PATH = '/profile/device-preferences/current-location';

const HomeHeader = () => {
    const { logo_navbar_expanded, logo_navbar_collapsed } = useBrandingRepository();
    const {
        currentAccount,
        store: { availableAccountsInfo }
    } = useAccountRepository();
    const { currentApp } = useMenuRepository();
    const navigate = useNavigate();
    const intl = useIntl();
    const [applicationModalOpen, setApplicationModalOpen] = useState<boolean>(false);
    const [location] = useLocalStorageState<string | null>('mobile-current-location', null);

    let accountName = '';
    if (currentApp === 'my' && availableAccountsInfo.find((a) => a.id === currentAccount)) {
        accountName = ' ' + availableAccountsInfo.find((a) => a.id === currentAccount)!.name;
    }
    return (
        <>
            <div
                className='border-border-default bg-background-surface inline-flex items-center justify-between self-stretch border-b px-5 pt-5 pb-4'
                id={ID}>
                <span className='flex flex-row gap-2 *:items-center'>
                    {!location && logo_navbar_expanded && (
                        <img
                            src={logo_navbar_expanded}
                            className='max-h-9 max-w-24 self-center'
                            alt='Logo'
                        />
                    )}
                    {location && logo_navbar_collapsed && (
                        <img
                            src={logo_navbar_collapsed}
                            className='max-h-9 max-w-24 self-center'
                            alt='Logo'
                        />
                    )}
                    {location && (
                        <div className='flex w-full flex-row justify-end'>
                            <button
                                type='button'
                                data-testid='home-header-location-badge'
                                className='bg-brand-secondary inline-flex cursor-pointer items-start justify-center gap-2 rounded-full border-0 px-2 py-1'
                                aria-label={intl.formatMessage({
                                    id: 'mobile.home-header.location-badge.aria-label',
                                    description: 'Accessibility label for the location badge on the home screen header; opens device location settings',
                                    defaultMessage: 'Change device location'
                                })}
                                onClick={() => navigate(DEVICE_LOCATION_PATH)}>
                                <SpotBadge
                                    className='text-background-surface justify-start text-center text-sm font-semibold'
                                    id={location}
                                />
                            </button>
                        </div>
                    )}
                </span>

                <div
                    data-testid='home-header-application-select-button'
                    className='inline-flex items-center justify-start gap-2'
                    onClick={() => setApplicationModalOpen(true)}>
                    {currentApp && (
                        <div className='text-foreground-default justify-start text-base font-semibold'>
                            {getApplicationDisplayName(currentApp)}
                            {accountName}
                        </div>
                    )}
                    <div className='bg-brand-muted flex size-9 items-center justify-center gap-2.5 rounded-full'>
                        <div className='text-background-surface relative flex items-center justify-center self-center overflow-hidden'>
                            <LuLayoutGrid size={18} />
                        </div>
                    </div>
                </div>
            </div>
            {applicationModalOpen && (
                <AppSelectModal
                    handleClose={() => setApplicationModalOpen(false)}
                    show={applicationModalOpen}
                />
            )}
        </>
    );
};

export default HomeHeader;
